import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-8" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_3 = { class: "flex h-full max-h-[500px] flex-col gap-2 overflow-y-auto overflow-x-hidden pr-2" }

import { computed } from 'vue';
import useChecklists from '@/checklists/useChecklists';
import ChecklistsProgress from '@/components/checklists/ChecklistsProgress.vue';
import Icon from '@/components/ui/Icon.vue';
import ChecklistsStep from '@/components/checklists/ChecklistsStep.vue';

interface Props {
  sectionId: string;
  onGoBack?: () => void;
  canGoBack: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsExpandedSection',
  props: {
    sectionId: null,
    onGoBack: { type: Function },
    canGoBack: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  sectionId: string;
  onGoBack?: () => void;
  canGoBack: boolean;
};



const { getSectionById, isStepLocked } = useChecklists();
const section = computed(() => getSectionById(props.sectionId));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.canGoBack)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            type: "button",
            class: "flex items-center gap-1 text-sm text-subtle cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onGoBack && __props.onGoBack(...args)))
          }, [
            _createVNode(Icon, {
              type: "chevron-left",
              class: "w-4 h-4"
            }),
            _createTextVNode(" Back ")
          ]),
          _createVNode(ChecklistsProgress, {
            section: __props.sectionId,
            steps: {
          total: _unref(section).steps.length,
          completed: _unref(section).completed
        }
          }, null, 8, ["section", "steps"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(section).steps, (step) => {
        return (_openBlock(), _createBlock(ChecklistsStep, {
          key: step.definition.id,
          step: step,
          "is-locked": _unref(isStepLocked)(step)
        }, null, 8, ["step", "is-locked"]))
      }), 128))
    ])
  ]))
}
}

})